export default __webpack_public_path__ + "static/media/Desktop_curve.ea0e9a0a.png";